import { gql } from "@apollo/client"

export const OTP_LOGIN = gql`
  mutation otpLogin($backupToken: String, $goBack: Boolean, $totpToken: String) {
    totpLogin(backupToken: $backupToken, goBack: $goBack, totpToken: $totpToken) {
      success
      errors
    }
  }
`
